import axios from 'axios';
import _ from 'lodash';

class RequestQueue {
  static _instance = null;

  static instance() {
    if (RequestQueue._instance === null) {
      RequestQueue._instance = new RequestQueue();
    }
    return RequestQueue._instance;
  }

  constructor() {
    this.request_queue = [];
    this.data_queue = [];
  }

  // returns a promise of this request
  async addToQueue({ url, method, params = {}, data = {}, cached = false }) {
    let existingData = false;
    if (cached) {
      existingData = _.find(this.data_queue, { url, method, params, data })
    }
    // empty queue, execute directly
    if (this.request_queue.length === 0) {
      if (cached && existingData) {
        EventManager.emit('next-request')
        return new Promise((resolve) => {
          resolve(existingData.response);
        })
      }
      const requestPromise = axios({
        method,
        url,
        params,
        data
      })
      try {
        this.request_queue.push(requestPromise)
        // store response to data queue if cached
        if (cached) {
          requestPromise.then(response => {
            this.data_queue.push({ url, method, params, data, response })
          }).catch(() => {});
        }
        const res = await requestPromise;
        this.request_queue.shift();
        EventManager.emit('next-request')
        return res;
      } catch(e) {
        this.request_queue.shift();
        EventManager.emit('next-request');
        return e;
      }
    } else {
      // has a previous queue, wait for previous queue to clear
      const waitPromise = new Promise((resolve, reject) => {
        EventManager.on('next-request', () => {
          if (waitPromise === this.request_queue[0]) {
            // check if data is available when it's this request's turn
            if (cached) {
              existingData = _.find(this.data_queue, { url, method, params, data })
            }
            if (cached && existingData) {
              resolve(existingData.response);
              return;
            }
            axios({
              method,
              url,
              params,
              data
            }).then(response => {
              // store response to data queue if cached
              if (cached) {
                this.data_queue.push({ url, method, params, data, response })
              }
              resolve(response)
            }).catch(e => {
              reject(e)
            })
          }
        })
      })
      try {
        this.request_queue.push(waitPromise);
        const res = await waitPromise;
        this.request_queue.shift();
        EventManager.emit('next-request');
        return res;
      } catch(e) {
        this.request_queue.shift();
        EventManager.emit('next-request');
        return e;
      }
    }
  }
}

export default RequestQueue.instance();
